import React from "react";

import { CASHBACK_LOAD_ERROR } from "../../../../../components/CashbackSection";
import { SectionRetryButton } from "../../../../../components/SectionRetryButton";
import { formatCurrency } from "../../../../../utils";
import { CashbackInfo } from "./CashbackInfo";
import {
  SideAmount,
  SideError,
  SideFigure,
  SideLabelRow,
  ValueLabel,
} from "./styles";
import { CashbackSideFigureProps } from "./types";

export const CashbackSideFigure: React.FC<CashbackSideFigureProps> = ({
  figure,
  mode,
  isError,
  onRetry,
}) => {
  if (isError) {
    return (
      <SideFigure $isMuted data-testid="saving-cashback-side">
        <ValueLabel>Cashback</ValueLabel>
        <SideAmount>—</SideAmount>
        <SideError>
          {CASHBACK_LOAD_ERROR}
          <SectionRetryButton onClick={onRetry} />
        </SideError>
      </SideFigure>
    );
  }
  if (!figure) {
    return null;
  }
  const { side, summary } = figure;
  return (
    <SideFigure data-testid="saving-cashback-side">
      <SideLabelRow>
        <ValueLabel>{side.label}</ValueLabel>
        <CashbackInfo caption={side.caption} summary={summary} mode={mode} />
      </SideLabelRow>
      <SideAmount data-testid="saving-cashback-total">
        {formatCurrency(side.amount)}
      </SideAmount>
    </SideFigure>
  );
};
